exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip--31vmS {\n  -webkit-box-shadow: 0 0 20px 7px rgba(0, 0, 0, 0.1);\n  -moz-box-shadow: 0 0 20px 7px rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0 20px 7px rgba(0, 0, 0, 0.1);\n}\n\n.__react_component_tooltip.show {\n  opacity: 1;\n}\n\n.box--2cied {\n  font-size: 0.6em;\n  text-transform: uppercase;\n  text-align: center;\n  width: 100px;\n  padding: 10px;\n  cursor: pointer;\n}\n\n.unfinished--1H5Ox {\n  border: 1px solid #eaeaea;\n  color: #526f46;\n}\n\n.inProgress--1q110 {\n  border: 1px solid #db9905;\n  color: #db9905;\n}\n\n.finished--3MHyW {\n  background: #db9905;\n  color: #fff;\n}\n\n.spacer--38Wbf {\n  flex-grow: 1;\n  border: 1px solid #eaeaea;\n}\n\n", ""]);

// exports
exports.locals = {
	"tooltip": "tooltip--31vmS",
	"box": "box--2cied",
	"unfinished": "unfinished--1H5Ox",
	"inProgress": "inProgress--1q110",
	"finished": "finished--3MHyW",
	"spacer": "spacer--38Wbf"
};